
import axios from 'axios';


export async function uploadFileToSignedUrl(
    file: File,
    signedUrl: string,
): Promise<void> {
    try {
        const response = await axios.put(signedUrl, file, {
            headers: {
                'Content-Type': file.type,
            },
        });

        // Check the response status
        if (response.status === 200) {
        } else {
            throw new Error(`Failed to upload file: ${response.statusText}`);
        }
    } catch (error: any) {
        console.error('Error uploading file:', error.message);
        throw error; // Re-throw the error for further handling if needed
    }
}
